// extracted by mini-css-extract-plugin
export default {"verticalCheckbox":"C3ekj"};